import { mapState, mapGetters } from 'vuex';

const customerMixin = {
  computed: {
    ...mapState({
      loading: (state) => state.customer.loading,
      notOnboardedLoading: (state) => state.customer.notOnboardedLoading,
      customerTableSearch: (state) => state.customer.customerTableSearch,
      notOnboardedTableSearch: (state) => state.customer.notOnboardedTableSearch,
      customerTableOptions: (state) => state.customer.customerTableOptions,
      notOnboardedTableOptions: (state) => state.customer.notOnboardedTableOptions,
      allCustomers: (state) => state.customer.allCustomers,
      allProspects: (state) => state.customer.allProspects,
      tableData: (state) => state.customer.tableData,
      newCustomer: (state) => state.customer.newCustomer,
      corporation: (state) => state.customer.corporation,
      sortedCorporation: (state) => state.customer.sortedCorporation,
      selectedCorp: (state) => state.customer.selectedCorp,
      activeProfileTab: (state) => state.customer.activeProfileTab,
      profileCompleteCount: (state) => state.customer.profileCompleted.length,
      profileIncompleteCount: (state) => state.customer.profileIncompleted.length,
      baseProfileCount: (state) => state.customer.baseProfile.length,
      notOnboardedCount: (state) => state.customer.notOnboardedCustomers.length,
      deactivatedTableSearch: (state) => state.customer.deactivatedTableSearch,
      deactivatedTableOptions: (state) => state.customer.deactivatedTableOptions,
      deactivatedProfiles: (state) => state.customer.deactivatedProfiles,
      customersCount: (state) => state.customer.customersCount,
      selectedPlanIds: (state) => state.customer.selectedPlanIds,
      filters: (state) => state.customer.filters,
      newCustomersUpload: (state) => state.customer.newCustomersUpload,
      parsingErrorObj: (state) => state.customer.parsingErrorObj,
      providerPlans: (state) => state.providerPlan.plans,
      adminCorp: (state) => state.admin.adminFilter.corpId,
    }),
    ...mapGetters([
      'isSmacAdmin',
      'isManufactureAdmin',
      'notOnboardedTableData',
      'allBranches',
    ]),
  },
  methods: {
    toggleActionModalCustomer(show, view) {
      this.$store.dispatch('changeCustomerValues', [{
        field: 'showActionModal',
        value: show,
      }, {
        field: 'actionModalView',
        value: view,
      }]);
    },
    getCount(hvac) {
      if (hvac) {
        return `${hvac.count}/${hvac.total}`;
      }
      return '--';
    },
    getHvacAge(s) {
      if (!s.systemAge) {
        return '--';
      }
      return `${s.systemAge} years`;
    },
    changePageCustomer(page) {
      this.$store.dispatch('changeTableOption', {
        field: 'page',
        value: page,
      });
      const get = async () => {
        this.$store.dispatch('getAllCustomers');
      };
      get();
    },
    changeRowCount(rowCount) {
      this.$store.dispatch('changeTableOption', {
        field: 'itemsPerPage',
        value: rowCount,
      });
      const get = async () => {
        this.$store.dispatch('getAllCustomers');
      };
      get();
    },
    checkBreakdownRisk(breakdownRisk) {
      if (breakdownRisk === 'High') {
        return 'red-text';
      }
      if (breakdownRisk === 'Medium') {
        return 'yellow-text';
      }
      return 'green-text';
    },
    async changePartner() {
      this.$store.dispatch('changeCustomerValue', {
        field: 'filters',
        value: {
          free: false,
          priority: false,
          prevent: false,
          standard: false,
          partner: false,
          pilot: false,
        },
      });
    },
    filterPercent(filters) {
      return filters.map((f) => `${f}%`).join(', ');
    },
  },
};

export default customerMixin;
